/* globals lp */
var _ = require('lodash');

;(function() {
  var register = lp.invariants.register;

  register('ImageAndPatternProperties', {
    'image properties in sync': function(editor){
      var props      = editor.activeElement.model.safeGet('style.newBackground')
        , hasImage   = editor.activeElement.model.exists('style.newBackground.image')
        , hasPattern = editor.activeElement.model.exists('style.newBackground.pattern');

      var hasImageAndPattern = hasImage && hasPattern;

      if (props && hasImageAndPattern && _.contains(['image', 'pattern'], props.type)) {
        return _.isEqual(props.pattern.image, props.image.image);
      } else {
        return true;
      }
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/invariants/new_background_properties_invariants.js
// module id = 1074
// module chunks = 0